import React, { useEffect, useCallback } from 'react';
import { createPortal } from 'react-dom';
import { LuCircleCheck, LuTriangleAlert, LuX } from 'react-icons/lu';
import './EmailSuccessToast.css';

const EmailSuccessToast = ({
  visible,
  message,
  submessage,
  onClose,
  duration = 8000,
  isError = false,
  tone,
  actionLabel,
  onAction,
}) => {
  const handleClose = useCallback(() => {
    if (onClose) onClose();
  }, [onClose]);

  useEffect(() => {
    if (!visible || !duration) return;
    const timer = setTimeout(handleClose, duration);
    return () => clearTimeout(timer);
  }, [visible, duration, handleClose]);

  if (!visible) return null;

  const normalizedTone = tone || (isError ? 'error' : 'success');
  const errorTone = normalizedTone === 'error';
  const StatusIcon = errorTone || normalizedTone === 'warning' ? LuTriangleAlert : LuCircleCheck;

  const toastContent = (
    <div
      className={`email-success-toast email-success-toast--${normalizedTone}`}
      role={errorTone ? 'alert' : 'status'}
      aria-live={errorTone ? 'assertive' : 'polite'}
    >
      <span className="email-success-toast__icon" aria-hidden="true">
        <StatusIcon />
      </span>
      <div className="email-success-toast__content">
        <p className="email-success-toast__message">{message}</p>
        {submessage && <p className="email-success-toast__submessage">{submessage}</p>}
      </div>
      {actionLabel && onAction && (
        <button type="button" className="email-success-toast__action" onClick={onAction}>
          {actionLabel}
        </button>
      )}
      <button className="email-success-toast__close" onClick={handleClose} aria-label="Close">
        <LuX aria-hidden="true" />
      </button>
    </div>
  );

  if (typeof document === 'undefined') return toastContent;
  return createPortal(toastContent, document.body);
};

export default EmailSuccessToast;

